/**
 * @desc 指定列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.IPage<defs.srm.SupplierInfoSpecifyDto>>;
export function request(
  params: API.srm.supplierInfo.getSpecifyListPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierInfo/specifyListPage`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
